import React from 'react';
import _ from 'lodash';
import moment from 'moment';

class StudioSubscriptions extends React.Component {

    state = { studio_subscriptions: [] }

    // Lifecycle
    componentWillMount() {
        const { studio_subscriptions } = this.props;
        this.setState({ studio_subscriptions: _.chain(studio_subscriptions).flatten().filter(s => !s.IdAppPlan).value() })
    }
    componentWillReceiveProps = nextProps => {
        const { studio_subscriptions } = nextProps;
        this.setState({ studio_subscriptions: _.chain(studio_subscriptions).flatten().filter(s => !s.IdAppPlan).value() })
    }
    //
        
    render() {
        const { studio_subscriptions } = this.state;
        return <section>
            {studio_subscriptions.map((s, i) => <div key={i} className="p-3 card shadow w-100 d-flex flex-row">
                <span className="align-self-center font-20 black">{s.TeamName}</span>
                <div className="d-flex flex-column ml-auto text-right align-self-center">
                    <span className="font-14 line1">{s.PlanName}</span>
                    <span className="font-8 line1">Expires at {moment(s.EndDate).format('MMM Do YYYY')}</span>
                    {s.Canceled && <span className="font-8 line1 text-danger">Cancelled</span>}
                </div>
            </div>)}
        </section>
    }
}

export default StudioSubscriptions;